import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CarrierProfileService } from '../../services/carrier-profile/carrier-profile.service';
import { AlertService } from '../../services/alert/alert.service';
import { LoadingService } from '../../services/loading/loading.service';

@Component({
    selector: 'app-manage-shipment-trackingurl',
    templateUrl: './manage-shipment-trackingurl.component.html',
    styleUrls: ['./manage-shipment-trackingurl.component.css'],
    standalone: false
})
export class ManageShipmentTrackingurlComponent implements OnInit {

    shipmentTrackingUrlForm: UntypedFormGroup;
    organization: any;
    organizationId: any;
    carrierId: any;
    businessType: any;
    scac: any;
    shipmentTrackingUrl: any;
    saveSuccessful = false;

    constructor(private fb: UntypedFormBuilder,
                public bsModalRef: BsModalRef,
                private carrierProfileService: CarrierProfileService,
                private alertService: AlertService,
                private tmssLoader: LoadingService) {
        this.shipmentTrackingUrlForm = this.fb.group({
            shipmentTrackingBaseUrl: [null, [Validators.required, Validators.maxLength(450)]],

        });
    }

    ngOnInit(): void {
        if (this.shipmentTrackingUrl) {
            this.shipmentTrackingUrlForm.get('shipmentTrackingBaseUrl').setValue(this.shipmentTrackingUrl);
        }
    }

    saveContactInfo(): void {
        if (this.shipmentTrackingUrlForm.invalid || !this.organization || !this.organization.carrierEntity) {
            return;
        }
        const updatedUrl = this.shipmentTrackingUrlForm.get('shipmentTrackingBaseUrl').value;
        this.organization.carrierEntity.shipmentTrackingUrl = updatedUrl;
        this.tmssLoader.show();
        this.carrierProfileService.saveTrackingUrl(this.organization).subscribe(
            (organization: any) => {
                this.organization = organization;
                this.shipmentTrackingUrl = organization && organization.carrierEntity
                    ? organization.carrierEntity.shipmentTrackingUrl
                    : updatedUrl;
                this.shipmentTrackingUrlForm.get('shipmentTrackingBaseUrl').setValue(this.shipmentTrackingUrl);
                this.shipmentTrackingUrlForm.markAsPristine();
                this.saveSuccessful = true;
                this.alertService.success('Successfully updated the Shipment Tracking Base URL');
                this.tmssLoader.hide();
            },
            (error: any) => {
                this.tmssLoader.hide();
                this.alertService.error('Error in updating the Shipment Tracking Base URL ' + (error && error.error ? error.error : ''));
            }
        );
    }

    getShipmentTrackingUrl() {
      // TODO: implement get logic
    }

    closeModal(): void {
        this.bsModalRef.hide();
    }
}
